import type { loader } from '@modules/elemental-page/loaders/elemental-page-loader.server';
import { getPreloadImageLink } from '@modules/images';
import type { MetaFunction } from '@remix-run/node';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import type { loader as rootLoader } from '~/root';
import type { loader as appLoader } from '~/routes/_app';
import { getRouteData } from '~/modules/root/util/get-route-data';

export const dynamicLinks: MetaFunction<
    typeof loader,
    { root: typeof rootLoader; 'routes/_app': typeof appLoader }
> = (props) => {
    const { data, matches } = props;
    const { appData } = getRouteData(matches);
    const imageConfigProps = appData?.imageConfigProps;
    if (!data) return [];
    const { modules, appDisplayMode } = data;
    if (!modules) return [];

    const heroImage = modules.find(
        (module) => module.type === 'EcomWelcomeModule'
    );

    const imageDesktop = heroImage?.image?.desktopSrc;
    const imageMobile = heroImage?.image?.mobileSrc;

    if (!imageDesktop) return [];

    if (imageMobile && appDisplayMode === 'mobile') {
        return getPreloadImageLink(imageConfigProps, undefined, imageMobile);
    }

    return [
        ...getPreloadImageLink(
            imageConfigProps,
            imageDesktop,
            undefined,
            getImagesSizes(890)
        ),
    ];
};
